import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { LegalTextsBody, LegalText, GenericError } from '../../model/legal.model'

export interface LegalState {
  loading: boolean | null
  errorMessage: string
  errorCode: string
  data: LegalText
}

interface FetchLegalTexts {
  body: LegalTextsBody
  tenant: string
  saleType: string
}

export const initialState: LegalState = {
  data: { text: '' },
  loading: null,
  errorMessage: '',
  errorCode: '',
}

export const legalSlice = createSlice({
  name: 'legalTexts',
  initialState,
  reducers: {
    fetchLegalTexts: (_state, _action: PayloadAction<FetchLegalTexts>) => {
      return {
        ...initialState,
        loading: true,
      }
    },
    fetchLegalTextsSuccess: (_state, action: PayloadAction<LegalText>) => {
      return {
        ...initialState,
        loading: false,
        data: action.payload,
      }
    },
    fetchLegalTextsError: (_state, action: PayloadAction<GenericError>) => {
      const { payload } = action
      return {
        ...initialState,
        loading: false,
        errorCode: payload.code || '500',
        errorMessage: payload.message || 'Error',
      }
    },
    resetLegalTexts: () => initialState,
  },
})

export const {
  fetchLegalTexts,
  fetchLegalTextsSuccess,
  fetchLegalTextsError,
  resetLegalTexts,
} = legalSlice.actions

const legalReducer = legalSlice.reducer

export default legalReducer
